/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'

import React from 'react'
import { BoxView, Button, View, Text, Avatar } from '@components/atoms'
import { Grid } from '@grid'
import { customerColumns } from '@grid/columns/main/CustomerColumn'
import {
	useAppSelector,
	useAppDispatch,
	customerActions,
	ApiGetDataStatus,
} from '@redux/index'
import { CustomerType } from '@schemas'
import { GridRenderCellParams, GridRowModel } from '@mui/x-data-grid'
import { useNavigate } from 'react-router-dom'

const CustomerPage = () => {
	const reduxDispatch = useAppDispatch()
	const navigate = useNavigate()

	// redux state
	const customerList: CustomerType[] = useAppSelector(
		state => state.customer.customerList,
	)
	const status: ApiGetDataStatus = useAppSelector(
		state => state.customer.customerListStatus,
	)

	const onAction = (iudFlag: string, aRow: GridRowModel) => {
		const newData = {
			iudFlag: iudFlag as 'I' | 'U' | 'D',
			customerId: aRow.id,
			name: aRow.name,
			email: aRow.email,
			profileColor: aRow.profileColor,
			verifiedYn: aRow.verifiedYn,
			createdAt: aRow.createdAt,
			confirmEmailNewsYn: aRow.confirmEmailNewsYn,
			password: { password: aRow.password || '' },
		}
		reduxDispatch(customerActions.UPDATE_CUSTOMER({ ...newData }))
	}

	return (
		<View css={style}>
			<BoxView title="고객 관리">
				<Grid
					rows={customerList}
					columns={customerColumns}
					loading={status === 'loading'}
					onAction={onAction}
					renderCell={{
						profileColor: (
							params: GridRenderCellParams<
								{ id: string; name: string; color: string },
								any,
								any
							>,
						) => {
							if (params.value === null) {
								return <></>
							}

							return (
								<Avatar
									picture={''}
									name={params.value.name}
									color={params.value.color}
								/>
							)
						},
						password: (params: GridRenderCellParams) => {
							return <Text>********</Text>
						},
					}}
					renderEditCell={{
						password: (params: GridRenderCellParams) => {
							const onClick = () => {
								navigate('/main/reset-customer-password')
								reduxDispatch(customerActions.EDIT_PASSWORD_CUSTOMER({ ...params.value }))
							}

							if (params.row.isNew) {
								return <></>
							}

							return (
								<Button variant="contained" onClick={onClick}>
									수정
								</Button>
							)
						},
					}}
				/>
			</BoxView>
		</View>
	)
}

export default CustomerPage

const style = css({})
